import select2 from "select2";

App.PrintifyImports = (function() {
  function init() {
    var $select = $("#catalog_breadcrumb");
    if (!$select.length || !$.fn.select2) { return; }
    if ($select.data("select2")) { return; }

    $select.select2({
      width: "100%",
      placeholder: $select.data("placeholder") || "Type to find a breadcrumb",
      allowClear: true
    });
  }

  $(init);

  return { init: init };
})();
